/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { candidacySummaryDataLastActivityActorTypeSchema } from './CandidacySummaryDataLastActivityActorTypeSchema'
import { candidacySummaryDataLastActivityLabelSchema } from './CandidacySummaryDataLastActivityLabelSchema'

export const candidacySummaryDataSchema = z.object({
	id: z.string(),
	campaign: z.object({ id: z.string(), title: z.string() }),
	pipelineStageId: z.string().nullable(),
	pipelineStageType: z.string().nullable(),
	createdAt: z.iso.datetime().nullable(),
	poolConsentGivenAt: z.iso.datetime().nullable(),
	lastActivityLabel: candidacySummaryDataLastActivityLabelSchema.nullable(),
	lastActivityAt: z.iso.datetime().nullable(),
	lastActivityActorType: candidacySummaryDataLastActivityActorTypeSchema.nullable(),
	lastActivityActorName: z.string().nullable(),
})

export type CandidacySummaryDataSchema = z.infer<typeof candidacySummaryDataSchema>
